import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useRuntimeConfig } from '#app'

export const useSiteStore = defineStore('site', () => {
  const config = useRuntimeConfig()
  const apiBase = config.public?.apiBase || '/api/v1'
  
  const settings = ref<Record<string, string>>({})
  const isLoading = ref(false)
  const isLoaded = ref(false)

  // Computed properties for easy access
  const defaultLogo = '/Logo_Technomac-snc_PNG.png'
  const siteLogo = computed(() => settings.value.site_logo ? getSafeImageUrl(settings.value.site_logo) : defaultLogo)

  const fetchSettings = async () => {
    if (isLoaded.value || isLoading.value) return;
    isLoading.value = true;
    try {
      const response = await $fetch(`${apiBase}/settings`)
      settings.value = (response as any).data || {}
      isLoaded.value = true
    } catch (error) {
      console.error('Failed to fetch site settings', error)
    } finally {
      isLoading.value = false
    }
  }

  // Update a single setting in the store (useful when admin updates it)
  const updateSetting = (key: string, value: string) => {
    settings.value[key] = value
  }

  return {
    settings,
    isLoading,
    isLoaded,
    siteLogo,
    fetchSettings,
    updateSetting
  }
})

// Helper to resolve URLs simply
function getSafeImageUrl(path: string): string {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path
  }

  const config = useRuntimeConfig()
  const apiBase = config.public?.apiBase || '/api/v1'
  const configuredBackendUrl = (config.public?.backendUrl || '').trim()

  const backendUrl = configuredBackendUrl
    ? configuredBackendUrl
    : (apiBase.startsWith('http') ? apiBase.replace(/\/api\/v1\/?$/, '') : '')

  if (!backendUrl) {
    return path.startsWith('/') ? path : `/${path}`
  }
  const normalizedBackendUrl = backendUrl.replace(/\/$/, '')
  
  if (path.startsWith('/')) {
    path = path.substring(1)
  }
  
  if (!path.startsWith('storage/')) {
    return `${normalizedBackendUrl}/storage/${path}`
  }
  return `${normalizedBackendUrl}/${path}`
}
